module.exports = __webpack_public_path__ + "static/media/rugby.cd558bdd.webp";